import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportsApi {
  prospektrBackendBaseURL = environment.prospektrBackendBaseURL;
  searchPropertyDetailsApi = 'searchProperty';

  reportsApi = 'valueReport';
  sharedValueReportApi = 'sharedValueReport';
  refreshReportsApi = 'refreshReport';

  getReportsApi = 'getAllValueReports';
  getPlanStats = 'plan-stats';
  downloadReportApi = 'downloadValueReport';
  downloadReportHtmlApi = 'downloadValueReportHtml';
  shareReportApi = 'shareReportUrl';
  updateValueReportApi = 'updateValueReport';
  shareReportToLoanOfficerApi = 'inviteAmcLoanOfficer';

  constructor(private http: HttpClient) { }

  getPlanStatus(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getPlanStats}`);
  }

  deleteReport(params): Observable<any> {
    return this.http.delete(`${this.prospektrBackendBaseURL}${this.reportsApi}`, {
      params: params,
    });
  }

  getAllReports(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}${this.getReportsApi}`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  getStatisticsData(params): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}scheduledSharingStatistics`, {
      params: params,
    });
  }

  getReportById(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .get(`${this.prospektrBackendBaseURL}${this.reportsApi}/${params.id}`)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  getSharedReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .get(`${this.prospektrBackendBaseURL}${this.sharedValueReportApi}/${params.id}/${params.type}`)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  createReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}${this.reportsApi}`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  createResearchStoreReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}generateResearchStoreReport`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  createFinalValueRSReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}generateFinalValueRSReport`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  createAppraiseRSReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}generateAppraiserRSReport`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  fetchResearchStoreReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}fetchResearchStoreReport`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  fetchAppraiserReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}fetchAppraiserReport`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  sendPreListingApproval(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}preListingApproval`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }


  updateResearchStoreReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}updateResearchStoreReport`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  updateReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .patch(`${this.prospektrBackendBaseURL}${this.reportsApi}/${params.id}`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  refreshReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .patch(`${this.prospektrBackendBaseURL}${this.refreshReportsApi}/${params.id}`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  downloadReport(params): Observable<any> {
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}${this.downloadReportApi}`, params, httpOptions)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  downloadReportAsHtml(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}${this.downloadReportHtmlApi}`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  searchPropertyDetails(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}${this.searchPropertyDetailsApi}`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  updateValueReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}${this.updateValueReportApi}`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }


  shareReport(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}${this.shareReportApi}`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  shareReportToLoanOfficer(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}${this.shareReportToLoanOfficerApi}`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }
}
